import { BaseModelService } from "models/base-model.service"
import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { TariffGroup } from "models/tariff-group.model"
import { TariffGroupSerializer } from "serializers/tariff-group.serializer"

export enum Direction { Left = 0, Right = 1 }
@Injectable()
export class TariffGroupsService extends BaseModelService<TariffGroup> {
  constructor() {
    super()

    this.configure({
      basePath:  'tariff_groups',
      key:       'tariff_group',
      pluralKey: 'tariff_groups',
      serializer: TariffGroupSerializer
    })    
  }

  /**
   * Обновляет состав тарифов в группе
   * @param group группа тарифов
   * @returns группы тарифов
   */
  updateContent(group: TariffGroup): Observable<TariffGroup> {
    let url = this.buildUrl(group.id, 'update_content')
    return this.patch(url, group).map(data => data['tariffGroups'] as TariffGroup)
  }

  /**
   * Меняет местами позиции двух групп тарифов
   * @param master первая группа тарифов
   * @param slave вторая группа тарифов
   * @returns первая группа тарифов с измененной позицией
   */
  swapPlaces(master: TariffGroup, slave: TariffGroup): Observable<TariffGroup> {
    let url = this.buildUrl(master.id, 'swap_places')
    let body = JSON.stringify({ slave: slave.id })
    return this.appHttp.patch(url, body).map((response) => {
      return this.processResponse(response)['tariffGroup'] as TariffGroup
    })
  }

  saveTranslations(id: number, translations: Object): Observable<Object> {
    let url = this.buildUrl(id)
    return this.patch(url, translations)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/tariff-groups.service.ts